module.exports = __webpack_public_path__ + "img/train-booking-active.31c483b9.svg";